
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.5 8a.5.5 0 01-.5-.5v-6A1.5 1.5 0 011.5 0h6a.5.5 0 010 1h-6a.5.5 0 00-.5.5v6a.5.5 0 01-.5.5zM12 18.5a6.5 6.5 0 116.5-6.5 6.5 6.5 0 01-6.5 6.5zm0-12a5.5 5.5 0 105.5 5.5A5.5 5.5 0 0012 6.5zM7.5 24h-6A1.5 1.5 0 010 22.5v-6a.5.5 0 011 0v6a.5.5 0 00.5.5h6a.5.5 0 010 1zm16-16a.5.5 0 01-.5-.5v-6a.5.5 0 00-.5-.5h-6a.5.5 0 010-1h6A1.5 1.5 0 0124 1.5v6a.5.5 0 01-.5.5zm-1 16h-6a.5.5 0 010-1h6a.5.5 0 00.5-.5v-6a.5.5 0 011 0v6a1.5 1.5 0 01-1.5 1.5z"}})])
          )
        }
      }
    